// src/config/globalProperties.js

import axios from 'axios';
import messageService from '@/services/messages.js';

/**
 * Le a configuracao que o Laravel expoe em /config e /version antes do mount e
 * publica em window + globalProperties.
 *
 * Dois clients, e a divisao e a do desenho: `API_AUTH` fala com o liberty/auth
 * (quem e a pessoa, o que ela pode, o menu entre aplicacoes) e `API_ATA`
 * fala com a API desta aplicacao (setores, participantes, reunioes,
 * atas e assinaturas). O token e o mesmo nos dois -- e o JWT da plataforma.
 */
export async function loadAppConfig(app) {
    try {
        const [configRes, versionRes] = await Promise.all([fetch('/config'), fetch('/version')]);

        const config = configRes.ok ? await configRes.json() : {};
        const versionJson = versionRes.ok ? await versionRes.json() : {};

        const finalConfig = {
            ...config,
            version: versionJson?.[config.APP_NAME]?.version,
        };

        app.config.globalProperties.APP_NAME = finalConfig.APP_NAME;
        app.config.globalProperties.APP_ENV = finalConfig.APP_ENV;
        app.config.globalProperties.URL_API_BASE_AUTH = finalConfig.URL_API_BASE_AUTH;
        app.config.globalProperties.URL_API_BASE_ATA = finalConfig.URL_API_BASE_ATA;
        app.config.globalProperties.URL_APP_ADMIN = finalConfig.URL_APP_ADMIN;
        app.config.globalProperties.APPMENU_CATALOG = finalConfig.APPMENU_CATALOG;
        app.config.globalProperties.API_ENV = finalConfig.API_ENV;
        app.config.globalProperties.version = finalConfig.version;
        app.config.globalProperties.message = messageService;

        window.appConfig = finalConfig;
        window.message = messageService;
        window.APP_ENV = finalConfig.APP_ENV;
        window.API_AUTH = axios.create({ baseURL: finalConfig.URL_API_BASE_AUTH || '' });
        window.API_ATA = axios.create({ baseURL: finalConfig.URL_API_BASE_ATA || '' });
        window.LOCAL_LOGIN = !!finalConfig.LOCAL_LOGIN;

        return finalConfig;
    } catch (error) {
        console.error('Erro ao carregar configuracoes da aplicacao:', error);
        return null;
    }
}
